module.exports = __webpack_public_path__ + "img/BG.21df2ff7.png";